import React from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
import WljOverlayModal from "./WljOverlayModal";

const cloneIcon = (icon, key) => {
  if (!icon) return null;
  if (React.isValidElement(icon)) {
    return React.cloneElement(icon, {
      key,
      className: ["material-symbols-sharp", icon.props.className]
        .filter(Boolean)
        .join(" "),
    });
  }
  return icon;
};

/**
 * Shared confirm overlay — icon + title + close.
 * One action is centered with equal space above and below.
 * Cancel + confirm stays bottom-right.
 */
const WljConfirmModal = ({
  show,
  title,
  icon = null,
  confirmLabel,
  onConfirm,
  onClose,
  variant = "danger",
  isLoading = false,
  showCancel = false,
  confirmDisabled = false,
}) => {
  const { t } = useTranslation();
  const isDanger = variant === "danger";

  if (!show) return null;

  return (
    <WljOverlayModal
      className="postAdd"
      data-modal-no-escape={isLoading ? "true" : undefined}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modalBorder d-flex justify-content-between align-items-center p-2">
            <h6 className={isDanger ? "wlj-modal-title--danger" : undefined}>
              {cloneIcon(icon, "title-icon")}
              {title}
            </h6>
            <CloseSharpIcon
              className="material-symbols-sharp me-2 pointer"
              onClick={() => {
                if (!isLoading) onClose();
              }}
            />
          </div>

          <div
            className={
              showCancel
                ? "d-flex align-items-center justify-content-end wlj-modal-footer"
                : "d-flex align-items-center justify-content-center wlj-modal-footer"
            }
          >
            {showCancel ? (
              <button
                type="button"
                className="closebtn me-2"
                onClick={onClose}
                disabled={isLoading}
              >
                {t("Connections.Cancel")}
              </button>
            ) : null}
            <button
              type="button"
              className={isDanger ? "wljDangerBtn" : "wljPrimaryBtn"}
              onClick={onConfirm}
              disabled={isLoading || confirmDisabled}
            >
              {cloneIcon(icon, "action-icon")}
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </WljOverlayModal>
  );
};

export default WljConfirmModal;
